import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import HeaderAndFooter from "./Views/HeaderAndFooter";
import Analysis from "./components/Analysis";
import Social from "./Views/Social";
import MyProfile from "./Views/MyProfile";
import LeaderBoards from "./Views/LeaderBoards";
import OtherProfile from "./Views/OtherProfile";
import Credits from "./Views/Credits";
import Play from "./Views/Play";
import FriendChat from "./Views/FriendChat";
import {UserProvider} from "./UserContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <UserProvider>
          <Router>
              <Routes>
                  <Route path={"/"} element={<HeaderAndFooter/>}>
                      <Route index={true} element={<App />}/>
                      <Route path={"/play"} element={<Play/>}/>
                      <Route path={"/analysis"} element={<Analysis/>} />
                      <Route path={"/social"} element={<Social/>} />
                      <Route path={"/my-profile"} element={<MyProfile />} />
                      <Route path={"/profile"} element={<OtherProfile/>} />
                      <Route path={"/leaderboards"} element={<LeaderBoards />} />
                      <Route path={"/credits"} element={<Credits/>} />
                      <Route path={"/messages/:friendName"} element={<FriendChat/>} />
                  </Route>
              </Routes>
          </Router>
      </UserProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
